import { Extension } from '@tiptap/core';
import { InputRule, emDash, ellipsis, openDoubleQuote, closeDoubleQuote, openSingleQuote, closeSingleQuote } from 'prosemirror-inputrules';

const leftArrow = new InputRule(/<-$/, '←');
const rightArrow = new InputRule(/->$/, '→');
const copyright = new InputRule(/\(c\)$/, '©');
const registeredTrademark = new InputRule(/\(r\)$/, '®');
const oneHalf = new InputRule(/1\/2$/, '½');
const plusMinus = new InputRule(/\+\/-$/, '±');
const notEqual = new InputRule(/!=$/, '≠');
const laquo = new InputRule(/<<$/, '«');
const raquo = new InputRule(/>>$/, '»');
const multiplication = new InputRule(/\d+\s?([*x])\s?\d+$/, '×');
const Typography = Extension.create({
    name: 'typography',
    addInputRules() {
        return [
            emDash,
            ellipsis,
            openDoubleQuote,
            closeDoubleQuote,
            openSingleQuote,
            closeSingleQuote,
            leftArrow,
            rightArrow,
            copyright,
            registeredTrademark,
            oneHalf,
            plusMinus,
            notEqual,
            laquo,
            raquo,
            multiplication,
        ];
    },
});

export default Typography;
export { Typography, copyright, laquo, leftArrow, multiplication, notEqual, oneHalf, plusMinus, raquo, registeredTrademark, rightArrow };
//# sourceMappingURL=tiptap-extension-typography.esm.js.map
